import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/en";

Vue.use(ElementUI, { locale });
// import './style/index.css'
import "./style/element-variables.scss";
Vue.use(ElementUI);
/* 这是全局样式 */
Vue.config.productionTip = false;

/*引入川辰vue开发包*/
import ccVueUtils from "cc-vue-utils";
ccVueUtils.ccRequest.setAppId("supnr"); // 这是由后台分配的APPID识别号，接口调用都需要用到

ccVueUtils.ccRequest.setBaseUrl("/"); // 这是由后台分配的APPID识别号，接口调用都需要用到

ccVueUtils.ccRequest.setLoginPage(process.env.VUE_APP_COOKIES_HOME); //登錄生效重定向

Vue.use(ccVueUtils);
//end--------------------------------------

/*引入川辰adminUi框架*/
import ccAdminUi from "cc-admin-ui";
Vue.use(ccAdminUi);
Vue.component("CcUploader", ccAdminUi.CcUploaderAliMultiV2);
//end--------------------------------------

// 设置cc-admin-ui的语言
import VueI18n from "vue-i18n";
import zh from "../packages/cc_merchant_sis/src/language/hk";
import en from "../packages/cc_merchant_sis/src/language/en";
import uiEn from "../packages/cc_merchant_sis/src/language/uiEn";
let langData = {
  // ...ccAdminUi.ZhLang,
  ...uiEn,
  ...zh,
  ...en,
};

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: "zh", // 语言标识
  messages: {
    zh: langData,
  },
});
//end--------------------------------------

/*引入常量管理组件*/
import CcConstantAdmin from "cc-constant-admin";
Vue.use(CcConstantAdmin);
//end--------------------------------------

/*引入API设置的列表*/
import APIS from "./api/api-config.js";
Vue.prototype.$apis = APIS;

import VueBus from "./utils/vue-bus";
Vue.use(VueBus);

import ccShopAdmin from "../packages/cc_merchant_sis/index";
import "../packages/cc_merchant_sis/src/scss/main.scss";

Vue.prototype.$ccShopAdmin = ccShopAdmin;
// Vue.prototype.$language = ccShopAdmin.languageEN;

//上傳工具方法
import uploadUtils from "../packages/cc_merchant_sis/src/utils/ossUtils.js";
Vue.prototype.$uploadUtils = uploadUtils;
Vue.prototype.storage = ccShopAdmin.localStorage;
let shopData = {};
try {
  shopData = ccShopAdmin.localStorage.getStorage("shop");
} catch (error) {}
Vue.prototype.$shopData = shopData;
Vue.prototype.$bus.$on("changeUser", (e) => {
  Vue.prototype.$shopData = e;
});

import utils from "../packages/cc_merchant_sis/src/utils/utils.js";
Vue.prototype.$utils = utils;

Vue.mixin({
  data() {
    return {};
  },
  methods: {
    language(name) {
      return this.$t(name);
    },
    random() {
      let code = [
        "Q",
        "W",
        "E",
        "T",
        "Y",
        "U",
        "I",
        "O",
        "P",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        0,
      ];
      var num = "";
      for (var i = 0; i < 5; i++) {
        num += code[Math.floor(Math.random() * 19)];
      }
      return num;
    },
    GetMenuList() {
      let menuList = {};
      if (localStorage.getItem(process.env.VUE_APP_menuList)) {
        try {
          menuList = JSON.parse(
            window.atob(
              window.atob(
                localStorage.getItem(process.env.VUE_APP_menuList).substring(5)
              )
            )
          );
        } catch (error) {
          this.$message.error("數據非法，請重新登錄");
          console.log(error);
          this.$router.push({ path: "/login" });
        }
      }
      Vue.prototype.$menuList = menuList;
    },
    SetMenuList(res) {
      return new Promise((s, r) => {
        try {
          let menuObj = {};
          if (res.data) {
            for (let i = 0; i < res.data.length; i++) {
              menuObj[res.data[i].code] = res.data[i];
            }
            let menu = window.btoa(window.btoa(JSON.stringify(menuObj)));
            localStorage.setItem(
              process.env.VUE_APP_menuList,
              this.random() + menu
            );
          }
          Vue.prototype.$menuList = menuObj;
          s(menuObj);
        } catch (error) {
          console.log(error);
          this.$message.error("數據非法，請重新登錄");
          this.$router.push({ path: "/login" });
        }
      });
    },
  },
  mounted() {},
});

new Vue({
  router,
  i18n,
  render: function(h) {
    return h(App);
  },
}).$mount("#app");
